<template>
  <!-- Content -->
  <d-row>
    <d-col lg="8" xl="9">
      <d-card class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center justify-content-between">
            <d-col cols="12" lg="6">
              <h6 class="m-0">{{ $t('puzzle.card.registration') }}</h6>
            </d-col>
            <d-col
              cols="12"
              lg="2"
              class="d-flex justify-content-end align-items-center"
            >
              <d-badge theme="light" class="status-badge">
                <span class="status-value">
                  {{ $t(getPuzzleStatusLabelKey(puzzle.status)) }}
                </span>
              </d-badge>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-form
                  ref="puzzleForm"
                  @confirmSyncQuestions="confirmSyncQuestions"
                />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="4" xl="3" sm="12">
      <sidebar-actions
        :model.sync="puzzle"
        :isGenerating="isGenerating"
        :isSyncingQuestions="isSyncingQuestions"
        @save="save"
        @fillCrossword="fillCrossword"
        @generateNewFromCurrentTemplate="generateNewFromCurrentTemplate"
        @requestFinalize="requestFinalize"
        @requestSyncQuestions="requestSyncQuestions"
      />
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleForm from './PuzzleForm.vue';
import SidebarActions from './SidebarActions.vue';
import { getPuzzleStatusLabelKey } from './PuzzleModel';
import loadPuzzleModelMixin from '../mixins/loadPuzzleModel';

export default {
  name: 'Puzzle-form',
  mixins: [loadPuzzleModelMixin],
  components: {
    PuzzleForm,
    SidebarActions,
  },
  data() {
    return {
      isGenerating: false,
      isSyncingQuestions: false,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'getPuzzle']),
    getPuzzleStatusLabelKey,
    fillCrossword() {
      this.$refs.puzzleForm.generateCrosswordFromGrid();
    },
    save() {
      this.$refs.puzzleForm.handleNormalSave();
    },
    generateNewFromCurrentTemplate() {
      this.isGenerating = true;

      this.$refs.puzzleForm
        .saveAndRegenerate()
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.isGenerating = false;
        });
    },
    generateBank(isManual = false) {
      this.$refs.puzzleForm.generateBank(isManual);
    },
    clearBank() {
      this.$refs.puzzleForm.clearBank();
    },
    requestFinalize() {
      this.$refs.puzzleForm.requestFinalize();
    },
    requestSyncQuestions() {
      this.$refs.puzzleForm.requestSyncQuestions();
    },
    confirmSyncQuestions() {
      if (this.isSyncingQuestions) return;

      this.isSyncingQuestions = true;

      this.$refs.puzzleForm
        .syncQuestions()
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.isSyncingQuestions = false;
        });
    },
  },
  watch: {
    '$route.params.puzzleId': {
      immediate: true,
      handler(id) {
        if (id) {
          const search = this.$store.state.puzzle.puzzleSearch;
          this.getPuzzle({ id, search });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.status-badge {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 6px 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-value {
  font-size: 14px;
  font-weight: 700;
  color: #000000;
}
</style>
